<script setup lang="ts">
interface selectButtonProps {
  items: Item[];
  selectedItem: string | number;
}
interface Item {
  id: string | number;
  label: string;
}
defineProps<selectButtonProps>();

const emit = defineEmits<{
  (eventName: 'selectItem', value: Item): void;
}>();

const selectItem = (item: Item) => {
  emit('selectItem', item);
};
</script>

<template>
  <ul class="select-buttons flex flex-wrap list-none text-sm pl-0 font-bold">
    <li
      v-for="item of items"
      :key="item.id"
      :class="{ selected: selectedItem === item.id }"
      class="mr-2 mb-2 flex align-items-center border-round-md cursor-pointer text-color-secondary"
      @click="selectItem(item)"
    >
      <span>{{ item.label }}</span>
    </li>
  </ul>
</template>

<style scoped lang="scss">
.select-buttons {
  li {
    padding: 2px 6px;
    background: white;
    border: 2px solid white;
    transition: 0.2s ease;
    &:hover {
      background: var(--primary-color-extra-light);
      border: 2px solid white;
      color: var(--primary-color) !important;
    }
    &.selected {
      background: var(--primary-color-light);
      border: 2px solid var(--primary-color-light);
      color: var(--primary-color-dark) !important;
    }
  }
}
</style>
